import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import * as actions from '../../../actions/response';
import { converter } from '../../../helpers/converter';
import { GetRegion } from '../../../constants';
import Slider from 'react-slick';
import decorators from '../../carousel/Decorators';
import PageWhatsNew from '../../user/PageWhatsNew'

class ModalWhatsNew extends React.Component {

  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      showModal: false,
    }
  }

  closeModal() {
    this.props.closeModal('WhatsNew');
  }

  render() {
    let apaWhatsNew = null;
    if (this.props.metadata.whatsnew_config) {
      apaWhatsNew = JSON.parse(this.props.metadata.whatsnew_config)
    }

    apaWhatsNew = apaWhatsNew[GetRegion()] || apaWhatsNew['default']

    if (apaWhatsNew && this.props.user && this.props.user.userType) {
      apaWhatsNew = apaWhatsNew[this.props.user.userType.toLowerCase()]
    }

    if(apaWhatsNew && !apaWhatsNew.enabled) {

      return null
    }

    const SampleNextArrow = (props) => {
      return (
          <div style={{display: 'none'}}></div>
      )
    }
    const SamplePrevArrow = (props) => {
      return (
          <div style={{display: 'none'}}></div>
      )
    }


    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />
    };
    return (
      <Modal show={true} id='modalSocialLevelUp'>
        <Modal.Header>
          <Button className='close close-modal' onClick={this.closeModal}>x</Button>
        </Modal.Header>
        <Modal.Body className='text-center success no-flecha'>

          <div>
            <Slider {...settings}>
              	{apaWhatsNew.pages.map((page, i) => {
                    return <div>
                      <PageWhatsNew
                        key={i}
                        index={i}
                        apaWhatsNew={apaWhatsNew}
                        translations={this.props.translations}
                        metadata={this.props.metadata}
                        page={page}
                        apaAssets={this.props.apaAssets}
                        />
                    </div>
                })}
            </Slider>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    metadata: state.metadata,
    translations: state.translations,
    apaAssets: state.asset,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalWhatsNew);
